import { render, staticRenderFns } from "./CancelFactForm.vue?vue&type=template&id=10f0112a&"
import script from "./CancelFactForm.vue?vue&type=script&lang=js&"
export * from "./CancelFactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports